import { render, staticRenderFns } from "./LoadingDots.vue?vue&type=template&id=5e64f3e6&scoped=true"
import script from "./LoadingDots.vue?vue&type=script&lang=js"
export * from "./LoadingDots.vue?vue&type=script&lang=js"
import style0 from "./LoadingDots.vue?vue&type=style&index=0&id=5e64f3e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64f3e6",
  null
  
)

export default component.exports